// AbortController polyfill for shell microfrontend
// This will be shared with other microfrontends

import 'abort-controller/polyfill';

// Ensure AbortController is available globally
if (typeof window !== 'undefined' && !window.AbortController) {
  const { AbortController, AbortSignal } = require('abort-controller');
  window.AbortController = AbortController;
  window.AbortSignal = AbortSignal;
}
